import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Box, Button, FlexColumn, Popover, Spinner, Tag, Text } from 'core/components';
import styled from 'styled-components';
import api from 'core/util/api';

const GlobalAclItemContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 8px;
  margin-bottom: 4px;
  border-radius: 4px;
  background-color: ${({ theme }) => (theme.name === 'light' ? '#fff' : 'rgba(255, 255, 255, 0.05)')};
  border: ${({ theme }) => theme.borders.thinLight};
  font-family: monospace;
  font-size: 14px;
`;

const GlobalAclItem = ({ matchType, pattern }) => (
  <GlobalAclItemContainer>
    <Text style={{ wordBreak: 'break-all' }}>{pattern}</Text>
    <Box flexShrink={0}>
      <Tag minimal>{matchType}</Tag>
    </Box>
  </GlobalAclItemContainer>
);

GlobalAclItem.propTypes = {
  matchType: PropTypes.string.isRequired,
  pattern: PropTypes.string.isRequired
};

class GlobalAclsPopover extends Component {
  static propTypes = {
    children: PropTypes.node
  };

  static defaultProps = {
    children: null
  };

  state = {
    globalAcls: null,
    loadingGlobalAcls: false
  };

  fetchGlobalAcls = () => {
    this.setState({ loadingGlobalAcls: true });
    api
      .get('/api/ui/devices/commands/acls?globalAcls=true')
      .then((response) => {
        this.setState({
          globalAcls: response.deviceCommandAcls,
          loadingGlobalAcls: false
        });
      })
      .catch(() => {
        this.setState({ loadingGlobalAcls: false });
      });
  };

  popoverContent = () => {
    const { globalAcls, loadingGlobalAcls } = this.state;

    return (
      <Box p={2} maxHeight={400} overflow="auto" minWidth={300}>
        {loadingGlobalAcls && (
          <Box display="flex" justifyContent="center" alignItems="center" py={3}>
            <Spinner size={20} />
          </Box>
        )}
        {!loadingGlobalAcls && globalAcls && (
          <FlexColumn gap={1}>
            <Text as="div" fontWeight="bold" mb={1}>
              Global Deny List
            </Text>
            <Text as="div" color="muted" mb={2}>
              These commands are always denied by Kentik and cannot be overridden.
            </Text>
            {globalAcls.rules?.length > 0 ? (
              globalAcls.rules.map((rule) => (
                <GlobalAclItem
                  key={`${rule.matchType}-${rule.pattern}`}
                  matchType={rule.matchType}
                  pattern={rule.pattern}
                />
              ))
            ) : (
              <Text color="muted">No global deny rules configured.</Text>
            )}
          </FlexColumn>
        )}
      </Box>
    );
  };

  render() {
    const { children } = this.props;

    return (
      <Popover
        minimal={false}
        boundary="viewport"
        targetTagName="span"
        content={this.popoverContent()}
        position="bottom"
        onOpening={this.fetchGlobalAcls}
      >
        <Button>{children}</Button>
      </Popover>
    );
  }
}

export default GlobalAclsPopover;
